"use client";
import { useQuery } from "@tanstack/react-query";
import { getPictures } from "@/lib/actions/gallery/get/getPictures";

export const useGetPictures = () => {
  return useQuery({
    queryKey: ["gallery"],
    queryFn: getPictures,
  });
};